// extracted by mini-css-extract-plugin
module.exports = {"container":"TextArea_container__T3xPC","input":"TextArea_input__pGo7q","count":"TextArea_count__ore_n","error":"TextArea_error__reSdi","disabled":"TextArea_disabled__NzFgT"};